export default __webpack_public_path__ + "static/media/Back_Plate_Detail.608b6ccd.png";